import type {
  AudioDevice,
  NameFormatSetting,
  EEnterBehavior,
  Language,
} from "@/stores/settingsStore";
import type { ChatTab } from "../../message/message";
import type { EPatientTabs } from "@/types/filter/tableFilters.types";

export enum EPracticeStaffSettingsKey {
  IS_DARK_MODE = "isDarkMode",
  NAME_FORMAT_SETTING = "nameFormatSetting",
  LANGUAGE = "language",
  AUDIO_DEVICE = "audioDevice",
  ADMINISTRATIVE_ASSISTANT_HINTS_DISABLED = "administrativeAssistantHintsDisabled",
  CHAT_ASSISTANT_HINTS_DISABLED = "chatAssistantHintsDisabled",
  SETTINGS_MENU_COLLAPSED = "settingsMenuCollapsed",
  CHAT_DEFAULT_TAB = "chatDefaultTab",
  CHAT_ENTER_BEHAVIOR = "chatEnterBehavior",
  CHAT_SYSTEM_MSGS = "chatSystemMessages",
  ANNO_CONTROL = "annoControl",
  DATE_FORMAT_INPUT = "dateFormatInput",
  DATE_FORMAT_DISPLAY = "dateFormatDisplay",
  HOUR_FORMAT_DISPLAY = "hourFormatDisplay",
  SCHEDULE_TIMELINE = "scheduleTimeline",
  DASHBOARD_TOUR_COMPLETED = "dashboardTourCompleted",
  OFFICES_CONTRACTS_TOUR_COMPLETED = "officesContractsTourCompleted",
  OFFICE_BILLING_TOUR_COMPLETED = "officeBillingTourCompleted",
  TUTORIAL_DIALOG_SEEN = "tutorialDialogSeen",
  DASHBOARD_DEFAULT_TAB = "dashboardDefaultTab",
  LAST_REFERRAL_PRACTICE = "lastReferralPractice",
  SKIP_CONFIRMATION_DIALOGS = "skipConfirmationDialogs",
  FORM_CUSTOMIZATION_BETA = "formCustomizationBeta",
  LAST_KNOWN_TZ = "lastKnownTZ",
}

export type TPracticeStaffUserSettings = {
  prefferences_v1?: Partial<{
    [EPracticeStaffSettingsKey.IS_DARK_MODE]: boolean;
    [EPracticeStaffSettingsKey.NAME_FORMAT_SETTING]: NameFormatSetting;
    [EPracticeStaffSettingsKey.LANGUAGE]: Language;
    [EPracticeStaffSettingsKey.AUDIO_DEVICE]: AudioDevice | null;
    [EPracticeStaffSettingsKey.ADMINISTRATIVE_ASSISTANT_HINTS_DISABLED]: boolean;
    [EPracticeStaffSettingsKey.CHAT_ASSISTANT_HINTS_DISABLED]: boolean;
    [EPracticeStaffSettingsKey.SETTINGS_MENU_COLLAPSED]: boolean;
    [EPracticeStaffSettingsKey.CHAT_DEFAULT_TAB]: ChatTab;
    [EPracticeStaffSettingsKey.CHAT_ENTER_BEHAVIOR]: EEnterBehavior;
    [EPracticeStaffSettingsKey.CHAT_SYSTEM_MSGS]: boolean;
    [EPracticeStaffSettingsKey.ANNO_CONTROL]: boolean;
    [EPracticeStaffSettingsKey.DATE_FORMAT_INPUT]: string;
    [EPracticeStaffSettingsKey.DATE_FORMAT_DISPLAY]: string;
    [EPracticeStaffSettingsKey.HOUR_FORMAT_DISPLAY]: string;
    [EPracticeStaffSettingsKey.SCHEDULE_TIMELINE]: boolean;
    [EPracticeStaffSettingsKey.DASHBOARD_TOUR_COMPLETED]: boolean;
    [EPracticeStaffSettingsKey.OFFICES_CONTRACTS_TOUR_COMPLETED]: boolean;
    [EPracticeStaffSettingsKey.OFFICE_BILLING_TOUR_COMPLETED]: boolean;
    [EPracticeStaffSettingsKey.TUTORIAL_DIALOG_SEEN]: boolean;
    [EPracticeStaffSettingsKey.DASHBOARD_DEFAULT_TAB]: EPatientTabs | string;
    [EPracticeStaffSettingsKey.LAST_REFERRAL_PRACTICE]: string | null;
    [EPracticeStaffSettingsKey.SKIP_CONFIRMATION_DIALOGS]: boolean;
    [EPracticeStaffSettingsKey.FORM_CUSTOMIZATION_BETA]: boolean;
    // Browser IANA zone last seen by the FE; BE falls back to it for emails when timeZone is "auto"
    [EPracticeStaffSettingsKey.LAST_KNOWN_TZ]: string;
  }>;
};
